import React from "react";
import Grid from "@material-ui/core/Grid";
import { sto } from "../../../Context/InshData";
import { Container } from "@material-ui/core";
import { txtA, txtE } from "../../../Label/Lbl";
import { useBody } from "./style";
import QrBarcode from "../Inv_Tempalte/A4/QrBarcode";
import { getcolor } from "../invCompany/A4/UnderHeader";

function Footer(props) {
  const { data, locInv, InvForFatora, found, premiApp ,sta} = props;
  const calssBody = useBody();
  const sty = {
    cntr: { textAlign: "center", fontFamily: "Amiri-Regular" },
    lft: { textAlign: "left", padingLeft: 1 },
    rit: { textAlign: "right", padingRight: 1 },
    dirR: { direction: "rtl", color: "black" },
    dirL: { direction: "ltr", padding: 2 },
  };
  const invColors = data?.StngIA?.colors;
  const secondColor = getcolor(invColors);
  return (
    <Container style={{ direction: "rtl" }}>
      <Grid
        item
        container
        style={{ paddingTop: "0.5rem", fontFamily: "Amiri-Regular" }}
      >
        <Grid item xs={7} container className={calssBody.totalItem} spacing={1} >
          <Grid item xs={4} className={calssBody.BdytotTitle2}>
            {(data.tot.tot_net - data.tot.amountOfVat).toFixed(2)}
          </Grid>
          <Grid item xs={7}>
            {" الإجمالي  " + " " + txtE.totalAmount}
          </Grid>
          {premiApp.billTemplate !== 7 && (
            <Grid item xs={4} className={calssBody.BdytotTitle2}>
              {data.tot.discount.toFixed(2)}
            </Grid>
          )}
          {premiApp.billTemplate !== 7 && (
            <Grid item xs={7}>
              {txtA.discount + " " + txtE.discount}
            </Grid>
          )}
          <Grid item xs={4} className={calssBody.BdytotTitle2}>
            {data.tot.amountOfVat.toFixed(2)}
          </Grid>
          <Grid item xs={7}>
            {"(15%)مجموع ضريبة القيمة المضافة Total VAT"}
          </Grid>
          <Grid item xs={4} className={calssBody.BdytotTitle2}>
            {data.tot.tot_net.toFixed(2)}
          </Grid>
          <Grid item xs={7}>
            {" الإجمالي مع الضريبة  " + " " + "Total Amount With Vat"}
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={12}></Grid>
        </Grid>
        <Grid item xs={3} container></Grid>
        {locInv?.ProcTypeInvProc != "03" && locInv?.ProcTypeInvProc != "04" &&
          <Grid item xs={2} container>
            <QrBarcode locInv={locInv} InvForFatora={InvForFatora} color={secondColor}  sta={sta}/>
          </Grid>
        }
        <Grid
          item
          container
          xs={12}
          spacing={1}
          style={{ fontWeight: "bold", textAlign: "center" }}
        >
          {premiApp.billTemplate !== 7 && (
            <Grid item xs={6}>
              {" "}
              {" توقيع البائع" + "     " + " Salesmans Sign "}
            </Grid>
          )}
          {premiApp.billTemplate !== 7 && (
            <Grid item xs={6}>
              {"توقيع المستلم" + "     " + " Receivrs Sign "}
            </Grid>
          )}

          {premiApp.billTemplate !== 7 && (
            <Grid item xs={6}>
              ____________________
            </Grid>
          )}

          {premiApp.billTemplate !== 7 && (

            <Grid item xs={6}>
              ____________________
            </Grid>
          )}


        </Grid>
      </Grid>
      <Grid item container style={sty.cntr}>
        <Grid container>
          <Grid item xs={12}>
            {InvForFatora.notes}
          </Grid>
          <Grid
            item
            xs={12}
            style={{ border: "solid 0.1px", maxHeight: "1cm", direction: "rtl", justifyContent: "center" }}
          >
            {found.BillNotes}
          </Grid>
          {premiApp.billTemplate !== 7 && (
            <Grid item xs={1}></Grid>
          )}
          {premiApp.billTemplate !== 7 && (
            <Grid item xs={12}>
              {"_____"}
            </Grid>
          )}
          {premiApp.billTemplate !== 7 && (
            <Grid item xs={12}>
              {sto.usernames}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Container>
  );
}
export default Footer;
